<template>
  <div class="mask">
    <!-- 京东联盟id -->
    <div class="mask-content">
      <div class="close-self" @click='closeMask'><i class="el-icon-close"></i></div>
      <div class="mask-title">粉丝画像</div>
      <!-- 抖音 -->
      <douyinportrait v-if="fansObj.type == 1" :fansObj="fansObj"></douyinportrait>
      <!-- 快手 -->
      <kuaishouportrait v-if="fansObj.type == 2" :fansObj="fansObj"></kuaishouportrait>
    </div>
  </div>
</template>
<script>
import douyinportrait from "@/components/cpx/douyin_portrait.vue"
import kuaishouportrait from "@/components/cpx/kuaishou_portrait.vue"
export default {
  name: "portrait_fans",
  components:{
    douyinportrait,
    kuaishouportrait
  },
  props: {
    fansObj: {
      type: 0  // 1抖音 2快手  3哔哩哔哩 4微博   5公众号
    }
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {},
  methods: {
    closeMask() {
      this.$emit('closeMask')
    }
  }
}
</script>
<style scoped>
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top:0;
  left:0;
  background: rgba(0,0,0,.5);
  z-index: 5;
}
.mask .mask-content .close-self {
  position: absolute;
  right: 20px;
  font-size: 24px;
  top: 35px;
  cursor: pointer;
}
.mask-content {
  width: 1200px;
  height: 800px;
  background-color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 41px 30px 0 30px;
  font-size: 14px;
  box-sizing: border-box;
  overflow: auto;
}
.mask-title {
  font-size: 18px;
  color: #3A3631;
  text-align: center;
  margin: 0 0 26px 0;
}
</style>